import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, compose, createStore } from "redux";
import { PersistConfig, persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import thunk from "redux-thunk";
import { storeReducer, whitelistStorage } from "./Store";

export const history = createBrowserHistory();

const persistConfig: PersistConfig = { key: "store", storage: storageSession, whitelist: whitelistStorage };

const enhancer = compose(applyMiddleware(thunk, routerMiddleware(history)));
const persistedReducer = persistReducer(persistConfig, storeReducer(history));

const configureStore = (initialState?: object) => {
    return createStore(persistedReducer, initialState!, enhancer);
};

export const store = configureStore();
export const persistor = persistStore(store);


// WEBPACK FOOTER //
// ./src/Store/ConfigureStore.tsx